import React from "react";
import { IconProps } from "./IconProps";

const PencilSimpleLineIcon: React.FC<IconProps> = ({
  size,
  thickness,
  ariaLabel,
  color = "currentColor",
}) => {
  switch (`${size}${thickness}`) {
    case "20Light":
      return (
        <svg
          aria-label={ariaLabel}
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M17.2594 5.85684L13.768 2.36622C13.6519 2.25011 13.5141 2.15801 13.3624 2.09518C13.2107 2.03234 13.0482 2 12.884 2C12.7198 2 12.5572 2.03234 12.4056 2.09518C12.2539 2.15801 12.1161 2.25011 12 2.36622L2.36641 11.9998C2.24983 12.1155 2.15741 12.2531 2.09451 12.4048C2.0316 12.5565 1.99948 12.7192 2.00001 12.8834V16.3748C2.00001 16.7063 2.1317 17.0243 2.36612 17.2587C2.60054 17.4931 2.91849 17.6248 3.25001 17.6248H16.375C16.5408 17.6248 16.6997 17.559 16.8169 17.4418C16.9342 17.3245 17 17.1656 17 16.9998C17 16.8341 16.9342 16.6751 16.8169 16.5579C16.6997 16.4407 16.5408 16.3748 16.375 16.3748H8.50938L17.2594 7.62481C17.3755 7.50873 17.4676 7.37092 17.5304 7.21925C17.5933 7.06757 17.6256 6.905 17.6256 6.74083C17.6256 6.57665 17.5933 6.41408 17.5304 6.26241C17.4676 6.11073 17.3755 5.97292 17.2594 5.85684ZM6.74141 16.3748H3.25001V12.8834L10.125 6.0084L13.6164 9.49981L6.74141 16.3748ZM14.5 8.61622L11.0094 5.12481L12.8844 3.24981L16.375 6.74122L14.5 8.61622Z"
            fill={color}
          />
        </svg>
      );
    default:
      return null;
  }
};

export default PencilSimpleLineIcon;
